export const FREE_TEST_QUESTION_LIMIT = 5;

/** Structural / non-playable rows that should not consume the free Test Mode allowance. */
export const FREE_TEST_EXCLUDED_CATS = new Set([
  "JOIN QUIZ",
  "INTRODUCTION",
  "SHOWROUNDS",
  "STARTROUND",
  "ENDROUND",
  "END QUIZ",
  "FINAL SCORES",
  "TOTALSCORES",
  "TOTAL SCORES",
  "SHOW SCORES",
  "ROUNDSCORES",
  "ROUND SCORES",
  "QUESTIONSCORES",
  "QUESTION SCORES",
]);

export function isSubActive(status) {
  return ["active", "trialing", "past_due"].includes(status || "");
}

export function getQuizTokenBalance(entitlementsOrProfile) {
  const ent = entitlementsOrProfile?.entitlements || entitlementsOrProfile || {};
  const nested = Number(ent?.quizTokens);
  return Number.isFinite(nested) ? nested : 0;
}

export function isLiveHostMode() {
  if (typeof localStorage === "undefined") return true;
  return localStorage.getItem("opt_test_mode") !== "On";
}

export function isTestHostMode() {
  return !isLiveHostMode();
}

export function questionCat(q) {
  return String(q?.CAT || q?.type || q?.cat || "").trim().toUpperCase();
}

export function isFreeTestContentQuestion(q) {
  const cat = questionCat(q);
  if (!cat) return true;
  return !FREE_TEST_EXCLUDED_CATS.has(cat);
}

/** How many playable questions are included in indexes 0..throughIdx (inclusive). */
export function countFreeTestQuestionsThrough(questions, throughIdx) {
  if (!Array.isArray(questions) || throughIdx < 0) return 0;
  let n = 0;
  const end = Math.min(throughIdx, questions.length - 1);
  for (let i = 0; i <= end; i++) {
    if (isFreeTestContentQuestion(questions[i])) n += 1;
  }
  return n;
}

/**
 * True when advancing TO targetIdx would show more than `limit` playable
 * questions in Test Mode (join/intro/round markers do not count).
 */
export function wouldExceedFreeTestLimit(
  questionsOrTargetIdx,
  targetIdxOrLimit,
  limit = FREE_TEST_QUESTION_LIMIT
) {
  // Back-compat: wouldExceedFreeTestLimit(targetIdx) / (targetIdx, limit)
  if (typeof questionsOrTargetIdx === "number") {
    const targetIdx = questionsOrTargetIdx;
    const lim = typeof targetIdxOrLimit === "number" ? targetIdxOrLimit : FREE_TEST_QUESTION_LIMIT;
    return Number(targetIdx) >= Number(lim);
  }
  const questions = questionsOrTargetIdx;
  const targetIdx = targetIdxOrLimit;
  return countFreeTestQuestionsThrough(questions, targetIdx) > limit;
}

export function canCreateFullQuiz(entitlements) {
  return isSubActive(entitlements?.subscriptionStatus) ||
         (entitlements?.eventCredits || 0) > 0 ||
         getQuizTokenBalance(entitlements) > 0;
}

export function enforceFreeQuestionLimit(questionCount, entitlements) {
  if (canCreateFullQuiz(entitlements)) return { allowed: true };
  const limit = FREE_TEST_QUESTION_LIMIT;
  if (questionCount <= limit) return { allowed: true };
  return { allowed: false, reason: `Free plan allows up to ${limit} questions. Please upgrade.` };
}
